import { render, staticRenderFns } from "./Consumos.vue?vue&type=template&id=3e5fe562"
import script from "./Consumos.vue?vue&type=script&lang=js"
export * from "./Consumos.vue?vue&type=script&lang=js"
import style0 from "./Consumos.vue?vue&type=style&index=0&id=3e5fe562&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports